// ─────────────────────────────────────────────
//  Sandbox boot flag — read by config.js BEFORE Firestore exists.
//
//  Mode is a boot-time decision, never a runtime one. `db` is referenced 90
//  times inside firebase/firestore.js and rebinding it after listeners have
//  attached leaves stale onSnapshot subscriptions that fail SILENTLY. So
//  entering or leaving sandbox sets this flag and reloads the page.
//
//  Every access is guarded: localStorage throws in Safari private mode, and
//  this module is imported at module scope by config.js, where a throw takes
//  the whole module graph down before React mounts.
// ─────────────────────────────────────────────
export const SANDBOX_KEY = "atc.sandbox";

export function isSandboxBoot() {
  try {
    return localStorage.getItem(SANDBOX_KEY) === "1";
  } catch {
    return false;
  }
}

export function enterSandbox() {
  try { localStorage.setItem(SANDBOX_KEY, "1"); } catch { /* ignore */ }
}

export function leaveSandbox() {
  try { localStorage.removeItem(SANDBOX_KEY); } catch { /* ignore */ }
}
